import { Button, Col, message, Row, Tooltip } from 'antd';
import axios from "axios";
import React, { Component } from 'react';
import { connect } from "react-redux";
import { setScanName } from "../../../action/preview_status.action";
import { RegionSelectionConstants } from "../../../actionTypes/region_selection.constant";
import { objectiveType, scanSpeed, specimenType, progressStage, cassetteType, slideType, queueLimits, queueColorMap, c240TaskType, queueActions } from '../../../utils/const';
import C240SlideView from './c240_slide_view';
import SlideAreaSelectionComponent from './c240_preview_area_selection';
import { AuthHeader } from "../../../helper/auth.token";
import {C240SlideStatus} from "../../../utils/const";
import '../../../asset/style/workflow/set-params.css';
import {updateEditorState} from '../../../action/c240_loader.action';
import { Input } from 'antd';
import cookie from "react-cookies";
import { getDeviceStatus } from "../../../action/device_status.action";

import {
    ScanOutlined,
    EyeOutlined,
    UpSquareOutlined,
    CloseCircleOutlined,    
} from '@ant-design/icons';

let SPECIMEN = {
    'PAP': specimenType.PAP,
    'HE': specimenType.HNE_TISSUE,
    'IHC': specimenType.IHC,
    'BLOOD': specimenType.BLOOD,
    'BM': specimenType.BM
}

let SCAN_SPEED = {
    'Minor': scanSpeed.FAST,
    'Few': scanSpeed.MEDIUM,
    'Major': scanSpeed.SLOW,
    'ZSTACK': scanSpeed.ZSTACK,
}

let OBJECTIVE = {
    '20x': objectiveType.TWENTY_X,
    '40x': objectiveType.FORTY_X,
    '100x': objectiveType.HUNDRED_X,
}

// let ALL_SLOTS_SELECTED = [true, true, true, true, true, true]
let ALL_SLOTS_UNSELECTED = [false, false, false, false, false, false];


class SingleCassetteComponent extends Component {
    constructor(props) {
        super(props)

        let cassetteSizeArray = [];

        if (this.props.cassetteType === cassetteType.SIX_1_BY_3_SLIDES) {
            cassetteSizeArray = [0, 1, 2, 3, 4, 5];
        } else if (this.props.cassetteType === cassetteType.TWO_2_BY_3_SLIDES) {
            cassetteSizeArray = [0, 1];
        }

        this.state = {
            specimenType: this.getKeyByValue(SPECIMEN, this.props.scannerProperties.defaultConfig.specimenType),
            scanSpeed: this.getKeyByValue(SCAN_SPEED, this.props.scannerProperties.defaultConfig.scanSpeed),
            objectiveType: this.getKeyByValue(OBJECTIVE, this.props.scannerProperties.defaultConfig.objectiveType),
            expandedSlide: false, // is true when user clicked on slide to modify scan settings
            selectedSlots: ALL_SLOTS_UNSELECTED,
            slotIndexes: cassetteSizeArray,
            device_id: this.props.device_id,
            cassetteSize: this.props.scannerProperties.cassetteSize,
            selectedSlotIndex: -1,
            defaultConfig: this.props.scannerProperties.defaultConfig,
            slide_names: {},
            maskForPathCacheBusterKey: (new Date()).getTime(), // used for busting cache (prevent loading cached image for same slot) of preview images
            barcodeVerify: false, // if true we use regex to validate slide name, if invalid Queue For Scan btn is disabled
        };
        this.slideElement =  { 
            0: React.createRef(),
            1: React.createRef(),
            2: React.createRef(),
            3: React.createRef(),
            4: React.createRef(),
            5: React.createRef(),
        }
    }

    componentDidMount = () => {
        console.debug("busting mask for path image cache");

        //Make SpecimenTypes Config Based
        let supportedSpecs = (((this.props.deviceStatus[this.props.device_id] || {}).scanner_health || {}).scanner_response||{}).supportedSpecimenTypes
        let specimens_=[]
        if(supportedSpecs!=undefined && (supportedSpecs||{}).length>0){
            (((this.props.deviceStatus[this.props.device_id] || {}).scanner_health || {}).scanner_response||{}).supportedSpecimenTypes.map((index)=>{
                specimens_.push(index);
            })
        }
        
        Object.keys(SPECIMEN).map((specimen) => {
            if(specimen=="HE"){
                if(!(specimens_.includes("HNE_TISSUE"))){
                    delete SPECIMEN[specimen]
                }
            }
            else if(!(specimens_.includes(specimen))){
                delete SPECIMEN[specimen]
            }
        });

        this.setState({
            maskForPathCacheBusterKey: (new Date()).getTime(),
            barcodeVerify: ((this.props.deviceStatus || {}).scanner_health || {}).verify_barcode, 
        });
        
        let slide_level_status = ((((this.props.deviceStatus||{}).scanner_health||{}).scanner_response||{}).slideLevelScanPreviewStatus);
        let slideNames = this.state.slide_names;
        let slides = this.state.slotIndexes.map((index) => {
            let slideKey = this.props.selectedCassette + "S" + index;
            let slide_name = (((slide_level_status||{})[slideKey]||{}).previewResponse||{}).slideName;
            slideNames[slideKey] = slide_name; 
        })
        this.setState({
            slide_names: slideNames,
        })
    }

    componentDidUpdate = (prevProps) => {

        let cassetteSizeArray = [];
        if (this.props.cassetteType === cassetteType.SIX_1_BY_3_SLIDES) {
            cassetteSizeArray = [0, 1, 2, 3, 4, 5];
        } else if (this.props.cassetteType === cassetteType.TWO_2_BY_3_SLIDES) {
            cassetteSizeArray = [0, 1];
        }

        if(this.state.slotIndexes.length != cassetteSizeArray.length ){
            this.setState({
                slotIndexes :  cassetteSizeArray
            });
        }


        // re-enable queue preview btn
        let slide_level_status = ((((this.props.deviceStatus||{}).scanner_health||{}).scanner_response||{}).slideLevelScanPreviewStatus);
        let prev_slide_level_status = ((((prevProps.deviceStatus||{}).scanner_health||{}).scanner_response||{}).slideLevelScanPreviewStatus);
        // logic for changing cache busting key based on right conditions
        if (this.props.selectedCassette !== prevProps.selectedCassette) {
            console.debug("change of cassette, busting mask for path cache key");
            let slideNames = this.state.slide_names;
            let slides = this.state.slotIndexes.map((index) => {
                let slideKey = this.props.selectedCassette + "S" + index;
                let slide_name = (((slide_level_status||{})[slideKey]||{}).previewResponse||{}).slideName;
                slideNames[slideKey] = slide_name;
            });
            this.setState({
                maskForPathCacheBusterKey: (new Date()).getTime(),
                slide_names: slideNames,
            });
        }
        if (this.props.barcodeCacheBustingKey !== prevProps.barcodeCacheBustingKey) {
            console.debug("change of barcode cache busting key, also busting mask for path cache key");
            this.setState({
                maskForPathCacheBusterKey: (new Date()).getTime(),
            });
        }

        this.state.slotIndexes.map((index) => {
            let state_of_slide = ((slide_level_status||{})[this.props.selectedCassette + "S" + String(index)]||{}).slideState;
            let prev_state_of_slide = ((prev_slide_level_status||{})[this.props.selectedCassette + "S" + String(index)]||{}).slideState;
            
            if( prev_state_of_slide !== C240SlideStatus.PREVIEW_DONE && state_of_slide === C240SlideStatus.PREVIEW_DONE ) {
                let slideKey = this.props.selectedCassette + "S" + index;
                let slide_info = ((slide_level_status||{})[slideKey]||{}).previewResponse;
                let slideNames = this.state.slide_names;
                slideNames[slideKey] = (slide_info||{}).slideName;
                this.setState({
                    slide_names: slideNames,
                });
            }
        });
        
        console.debug("deviceStatus", this.props.deviceStatus);
        const slidesInCassette = this.props.cassetteType === cassetteType.TWO_2_BY_3_SLIDES ? 2 : 6;
        for (let slide_idx = 0; slide_idx < slidesInCassette; slide_idx++) {
            const slide_key = `${this.props.selectedCassette}S${slide_idx}`;
            const single_slide_status = (slide_level_status||{})[slide_key];
            const slide_state = (single_slide_status||{}).slideState;
            const prev_slide_state = ( (prev_slide_level_status||{})[slide_key] || {} ).slideState;
            console.debug("slide_state is", slide_state, "prev_slide_state is", prev_slide_state);
            if (prev_slide_state === C240SlideStatus.INITIAL
                 && slide_state !== C240SlideStatus.INITIAL) {
                    console.debug("slide state changed from INITIAL, so busting mask for path cache key");
                    this.setState({
                        maskForPathCacheBusterKey: (new Date()).getTime(),
                    });
                     this.props.enablePreviewBtn(this.props.selectedCassette, slide_idx);
            }
            // enable preview btn every time we go to initial state
            if (prev_slide_state !== C240SlideStatus.INITIAL
                 && slide_state === C240SlideStatus.INITIAL) {
                this.props.enablePreviewBtn(this.props.selectedCassette, slide_idx);
            }

            if (prev_slide_state === C240SlideStatus.PREVIEW_DONE
                 && slide_state !== C240SlideStatus.PREVIEW_DONE) {
                this.props.enableQScanBtn(this.props.selectedCassette, slide_idx);
            }

            if (prev_slide_state !== C240SlideStatus.SCAN_CRASHED
                && slide_state === C240SlideStatus.SCAN_CRASHED) {
                this.props.enableQScanBtn(this.props.selectedCassette, slide_idx);
            }

            // enable preview on every scan crash
            if (prev_slide_state !== C240SlideStatus.SCAN_CRASHED
                && slide_state === C240SlideStatus.SCAN_CRASHED) {
                this.props.enablePreviewBtn(this.props.selectedCassette, slide_idx);
            }

            if (prev_slide_state !== C240SlideStatus.PREVIEW_DONE
                && slide_state === C240SlideStatus.PREVIEW_DONE) {
                    console.debug("slide state changed to PREVIEW_DONE, so busting mask for path cache key");
                    this.setState({
                        maskForPathCacheBusterKey: (new Date()).getTime(),
                    });
            }
        }

        if((prevProps.c240LoaderStatus||{}).editor_mode !== (this.props.c240LoaderStatus||{}).editor_mode){
            let slides = this.state.slotIndexes.map((index) => {
            let slideKey = this.props.selectedCassette + "S" + index;
            let slide_name = (((slide_level_status||{})[slideKey]||{}).previewResponse||{}).slideName;
            let slideNames = this.state.slide_names;
            slideNames[slideKey] = slide_name;
            this.setState({
                slide_names: slideNames,
            })
        })
        }
        if ((prevProps.deviceStatus.uiBusy || {}).status === true
                && (this.props.deviceStatus.uiBusy || {}).status === false) {
            this.setState({
                isFetching: false,
            })
        }
        if ((this.state.cassetteSize === 1 || this.state.cassetteSize === 2) && 
            prevProps.previews[0] !== undefined && this.props.previews[0] !== undefined &&
            prevProps.previews[0].status !== this.props.previews[0].status && this.props.previews[0].status === RegionSelectionConstants.CONFIRMED) {
            this.onStartScanning();
        }
    }

    getKeyByValue(object, value) {
        return Object.keys(object).find(key => object[key] === value);
    }

    call = (endpoint, options="", callback=null, show_info=true, errcallback=null) => {
        // callback is called on 200 response code with response.data as argument
        let url = `/server/scano/1/api~hts~` + endpoint + "/" + options;
        console.debug("path ", url, options);
        axios.get(url, { headers: { Authorization: AuthHeader() } })
            .then(response => {
                if (response.status !== 200) {
                    if (errcallback !== null) {
                        errcallback(response.status, null);
                    }
                    console.error("Failed to Queue Prev");
                } else {
                    console.debug(response.data);
                    if (show_info) {
                        message.info(response.data.message);
                    }
                    if (callback !== null) {
                        callback(response.data);
                    }
                }
            })
            .catch(err => {
                if (errcallback !== null) {
                    errcallback(-1, err);
                }
                console.log(err);
            })
    };

    appendScanToQueue = (queue, rack, tray, slide, slide_type, task_type) => {
        let newQueueState = JSON.parse(JSON.stringify(queue))
        let newQueue = newQueueState.queue

        //Append the new scan at the end
        let taskToAppend = {rack: rack, slide: slide, slideType: slide_type, taskType: task_type, tray: tray }

        newQueue.push(taskToAppend)
        this.fetchUpdatedQueue(rack, tray, slide, task_type, queueActions.ADD, newQueueState);

    }

    // add slide to queue for preview
    queuePreviewOnly = (slide_id) => {
        this.props.onPreviewOnlyClick(this.props.selectedCassette, slide_id); // disable btn as quickly as clicked
        console.debug(this.props.selectedCassette, slide_id);
        const trayKey = this.props.selectedCassette;
        let rack = parseInt(trayKey.split("T")[0].split("R")[1]);
        let tray = parseInt(trayKey.split("T")[1]);
        const _this = this;
        const callback = () => {
            _this.props.dispatch(getDeviceStatus(_this.props.device_id));
        }
        const slide_type = this.props.cassetteType === cassetteType.TWO_2_BY_3_SLIDES ? slideType.SLIDE_2_BY_3_INCH : slideType.SLIDE_1_BY_3_INCH;

        this.appendScanToQueue(this.props.queue_state, rack, tray, slide_id, slide_type, c240TaskType.TAKE_SLIDE_PREVIEW);

        this.call("queue_preview", `?rack=${rack}&tray=${tray}&slide=${slide_id}&slide_type=${slide_type}`, callback, false, callback);
    }

    // add slide to queue for scanning
    queueScan = (slide_id) => {
        this.props.onQScanClick(this.props.selectedCassette, slide_id);
        // slide_id is either 0, 1, 2, 3, 4 or 5
        const trayKey = this.props.selectedCassette;
        let rack = parseInt(trayKey.split("T")[0].split("R")[1]);
        let tray = parseInt(trayKey.split("T")[1]);
        const _this = this;
        const callback = (resp) => {
            _this.props.dispatch(getDeviceStatus(_this.props.device_id));
            console.log('queued scan of selected region', `R${rack}T${tray}S${slide_id}`);
        };
        const slide_type = this.props.cassetteType === cassetteType.TWO_2_BY_3_SLIDES ? slideType.SLIDE_2_BY_3_INCH : slideType.SLIDE_1_BY_3_INCH;

        this.appendScanToQueue(this.props.queue_state, rack, tray, slide_id, slide_type, c240TaskType.TAKE_SCAN_OF_SELECTED_REGION);

        this.call("queue_scan", `?rack=${rack}&tray=${tray}&slide=${slide_id}&slide_type=${slide_type}`, callback, false );
    }

    // preview + auto thresholding + scan
    queueAutoScan = (slide_id) => {
        this.props.onPreviewOnlyClick(this.props.selectedCassette, slide_id); 
        const trayKey = this.props.selectedCassette;
        let rack = parseInt(trayKey.split("T")[0].split("R")[1]);
        let tray = parseInt(trayKey.split("T")[1]);
        const _this = this;
        const callback = (resp) => {
            _this.props.dispatch(getDeviceStatus(_this.props.device_id));
            console.log('queued auto scan', `R${rack}T${tray}S${slide_id}`);
        };
        const slide_type = this.props.cassetteType === cassetteType.TWO_2_BY_3_SLIDES ? slideType.SLIDE_2_BY_3_INCH : slideType.SLIDE_1_BY_3_INCH;

        this.appendScanToQueue(this.props.queue_state, rack, tray, slide_id, slide_type, c240TaskType.TAKE_AUTO_SCAN);

        this.call("queue_auto_scan", `?rack=${rack}&tray=${tray}&slide=${slide_id}&slide_type=${slide_type}`, callback, false);
    }

    // clear slide
    resetSlide = (slide_id) => {
        // slide_id is either 0, 1, 2, 3, 4 or 5
        const trayKey = this.props.selectedCassette; // eg: trayKey is "R1T1"
        let rack = parseInt(trayKey.split("T")[0].split("R")[1]);
        let tray = parseInt(trayKey.split("T")[1]);
        const _this = this;
        const callback = function() {
            _this.props.dispatch(getDeviceStatus(_this.props.device_id));
            console.log('cleared slide', `R${rack}T${tray}S${slide_id}`);
        };
        this.call("clear_slide", `?rack=${rack}&tray=${tray}&slide=${slide_id}`, callback, false);
    }

    // remove preview
    removePreview = (slide_id) => {
        // slide_id is either 0, 1, 2, 3, 4 or 5
        const trayKey = this.props.selectedCassette; // eg: trayKey is "R1T1"
        let rack = parseInt(trayKey.split("T")[0].split("R")[1]);
        let tray = parseInt(trayKey.split("T")[1]);
        const _this = this;
        const callback = function() {
            _this.props.dispatch(getDeviceStatus(_this.props.device_id));
            console.log('removed preview for slide', `R${rack}T${tray}S${slide_id}`);
        };
        this.call("remove_preview", `?rack=${rack}&tray=${tray}&slide=${slide_id}`, callback, false );
    }

    expandedSlideView = (slot_id) => {
        this.props.onStartChangeScanRegionCallback(); // hides rack
        this.props.dispatch(updateEditorState(true))
        this.setState({
            selectedSlotIndex: slot_id,
            expandedSlide: true,
        });
    }

    closeExpadedSlideView = () => {
        this.props.onFinalizeScanRegionCallback(); // shows rack
        this.props.dispatch(updateEditorState(false))
        this.setState({
            expandedSlide: false,
            maskForPathCacheBusterKey: (new Date()).getTime(),
        });
    }

    onTabClick = (key) => {
        this.setState({
            selectedSlotIndex: key
        })
    }

    fetchUpdatedQueue = (rack, tray, slide, taskType, operationType, queueData=null) => {

        let currQueueState;
        let currQueue;
        let index = -1;

        if(operationType !== queueActions.ADD){
            currQueueState = JSON.parse(JSON.stringify(this.props.queue_state));
            currQueue = currQueueState.queue;
            index = this.getIndexInQueue(rack, tray, slide, taskType, currQueue);
        } else {
            index = queueData.queue.length-1;
            currQueueState = JSON.parse(JSON.stringify(queueData));
            currQueue = currQueueState.queue;
        }

        let intermediateQueueState = JSON.parse(JSON.stringify(currQueueState));
        let intermediateQueue = intermediateQueueState.queue;

        if(operationType === queueActions.PRIORITISE){
            if(index !== -1){
                intermediateQueue[index].queueColorMap = queueColorMap.PRIORITISE;
                currQueue.splice(queueLimits.PRIORITISE_TASK, 0, currQueue[index]);
                currQueue.splice(index+1,1);    
            }
        } else if (operationType === queueActions.REMOVE){
            if(index !== -1){
                intermediateQueue[index].queueColorMap = queueColorMap.REMOVE;
                currQueue.splice(index,1); 
            }
        } else if (operationType === queueActions.ADD){
            intermediateQueue[index].queueColorMap = queueColorMap.ADD;
        }
        this.props.updateQueue(intermediateQueueState);
        this.props.disableQueueInteraction(true);

        setTimeout(() => {
            
            //Second Step of Animation if action is PRIORITISE:
            if(operationType === queueActions.PRIORITISE){
                let phasedQueueState = JSON.parse(JSON.stringify(currQueueState));
                let phasedQueue = JSON.parse(JSON.stringify(currQueue));
                phasedQueue[queueLimits.PRIORITISE_TASK].queueColorMap = queueColorMap.ADD;
                phasedQueueState.queue = phasedQueue;
                
                setTimeout(() => {
                    this.props.updateQueue(phasedQueueState);
                    this.props.disableQueueInteraction(false);
                },100);
            }

            currQueueState.queue = currQueue;
            this.props.updateQueue(currQueueState);
            if(operationType !== queueActions.PRIORITISE){
                this.props.disableQueueInteraction(false);
            }
          }, 100);
        
    }

    getIndexInQueue = (rack, tray, slide, taskType, currQueue) => {
        let len = currQueue.length;
        for (let i=0; i<len; i++){
            let currTask = currQueue[i];
            if (currTask.taskType === taskType && currTask.rack === rack && currTask.slide === slide && currTask.tray === tray){
                return i;
            }
        }
        return -1;
    }
    
    prioritiseTask = (e, rack, tray, slide, taskType, cb) => {
        this.fetchUpdatedQueue(rack, tray, slide, taskType, queueActions.PRIORITISE);
        this.call("prioritise_task",`?rack=${rack}&tray=${tray}&slide=${slide}&taskType=${taskType}`, cb, true)
    }

    removeTask = (e, rack, tray, slide, taskType, cb) => {
        this.fetchUpdatedQueue(rack, tray, slide, taskType, queueActions.REMOVE);
        this.call("remove_task",`?rack=${rack}&tray=${tray}&slide=${slide}&taskType=${taskType}`, cb, true)
    }

    isValidSlideName = (name_to_check) => {
        let regex=new RegExp('^$')
        regex = new RegExp(((this.props.deviceStatus || {}).scanner_health || {}).regex_barcode)
        return !regex.test(name_to_check)
    }

    onChangeName = (event, rack, tray, id) => {
        let slide_name = event.target.value;
        let url = `/server/devices/${this.props.device_id}/set_slide_name_v2/?slotID=${id}&rack=${rack}&tray=${tray}&slideName=${slide_name}`;
        axios.get(url).then(res => {
            console.log("name updated")
        })
        let slideNames = this.state.slide_names;
        slideNames[`R${rack}T${tray}S${id}`] = slide_name;
        this.setState({
            slide_names: slideNames,
        });
        this.props.dispatch(setScanName(id, slide_name))
    }

    render() {
        let is_superuser = cookie.loadAll().superuser === "true";
        const slideKey = this.props.selectedCassette + "S" + this.state.selectedSlotIndex;
        let slide_level_status = ((((this.props.deviceStatus||{}).scanner_health||{}).scanner_response||{}).slideLevelScanPreviewStatus)
        let slide_info = ((slide_level_status||{})[slideKey]||{}).previewResponse;
        let startPreview = {
            response: null, 
            slideName: "Something Wrong",
            slideState: C240SlideStatus.INITIAL,
            speed: "MEDIUM",
            specimenType: "IHC",
            scanOutputFormat: "JPG",
            stepSize: 1,
            zStackLevels: 10,
            numWBCToScan: -1,
            objectiveType: "FORTY_X",
            message: "",
            actionOngoing: false,
            doTilingOnly: false,
            doTilingAfterScan: false,
            slideKey: slideKey
        };
        let preview = {
            response: slide_info, 
            slideName: (slide_info||{}).slideName,
            status: "fetched_image",
            speed: (slide_info||{}).scanSpeed,
            specimenType: (slide_info||{}).specimenType,
            scanOutputFormat: (slide_info||{}).scanOutputFormat,
            stepSize: (slide_info||{}).zstackStepSize,
            zStackLevels: (slide_info||{}).zstackLevels,
            objectiveType: (slide_info||{}).objectiveType,
            message: "",
            actionOngoing: false,
            doTilingOnly: false,
            doTilingAfterScan: false,
            slideKey: slideKey,
            dropDistancePoint: (slide_info||{}).dropDistancePoint,
            numWBCToScan: (slide_info||{}).numWBCToScan,
        };

        console.debug("this.props.cassetteType is ", this.props.cassetteType);
        const mySlideType = this.props.cassetteType === cassetteType.TWO_2_BY_3_SLIDES ? slideType.SLIDE_2_BY_3_INCH : slideType.SLIDE_1_BY_3_INCH;

        let slides = this.state.slotIndexes.map((index) => {
            const trayKey = this.props.selectedCassette;
            let rack = parseInt(trayKey.split("T")[0].split("R")[1]);
            let tray = parseInt(trayKey.split("T")[1]);
            let queue_elems = JSON.parse(JSON.stringify(this.props.queue_state['queue']));
            delete queue_elems['0'];
            delete queue_elems['1']; 

            let single_slide_status = (slide_level_status||{})[this.props.selectedCassette + "S" + String(index)];
            single_slide_status = single_slide_status !== undefined ? single_slide_status : startPreview;

            let local_slide_name = this.state.slide_names[`R${rack}T${tray}S${index}`]
            return <Row key={trayKey + "S" +  index.toString()} style={{display:"flex"}} span={mySlideType === slideType.SLIDE_2_BY_3_INCH ? 8 : 4} align={'middle'} justify={'center'}
                className={this.state.selectedSlotIndex === index && this.state.expandedSlide === true ? "active-slot" : ""}>
                <Col span={17} style={{display: "flex", flexDirection: "row", justifyContent: "center", margin: "3px 0px"}}>
                    <C240SlideView 
                        key={trayKey + "S" +  index.toString()}
                        ref={this.slideElement[index]}
                        expandedSlide={this.state.expandedSlide} 
                        expandedSlideView={this.expandedSlideView} 
                        slot_id={index}
                        mySlideType={mySlideType}
                        defaultConfig={this.state.defaultConfig}
                        cassetteKey={this.props.selectedCassette}
                        barcodeTaken={this.props.barcodeTaken}
                        slideState={(single_slide_status||{}).slideState}
                        slide_status = {single_slide_status}
                        device_id={this.state.device_id}
                        maskForPathCacheBusterKey={this.state.maskForPathCacheBusterKey} />
                </Col>
                <Col span={7} style={{display:"flex",flexDirection: "column",justifyContent: "center"}}>
                
                { ( true 
                    && (single_slide_status || {}).slideState === C240SlideStatus.SCAN_DONE ) ? 
                <div>
                    {/* <Tooltip placement="top" title={"Reset Slide"}> */}
                        <Button 
                            className="scan-btn"
                            size="large"
                            onClick={(e) => {e.stopPropagation(); this.resetSlide(index)}}
                            disabled={false}>
                            <CloseCircleOutlined />
                            <span> Discard Scan </span>   
                        </Button>                     
                    {/* </Tooltip> */}
                </div> : null}
                { (single_slide_status||{}).slideState === C240SlideStatus.INITIAL || (single_slide_status||{}).slideState === C240SlideStatus.SCAN_CRASHED ? 
                <div>
                    {/* <Tooltip placement="top" title={"Preview Only"}> */}
                        <Button 
                            className="black-scan-btn"
                            size="large"
                            onClick={(e) => {e.stopPropagation(); this.queuePreviewOnly(index)}}
                            disabled={this.props.cassetteQPreviewBtnDisable[index] || this.props.remove_queue_interaction}>
                            <EyeOutlined />
                            <span> Capture Preview </span>
                        </Button>
                    {/* </Tooltip> */}
                    
                    {/* <Tooltip placement="top" title={"Auto Scan"}>
                        <Button className="" 
                            size="large" 
                            type="primary"
                            onClick={(e) => {e.stopPropagation(); this.queueAutoScan(index)}}
                            disabled={this.props.cassetteQPreviewBtnDisable[index] || this.props.remove_queue_interaction}
                            style={{ marginLeft:"5px" }}>
                            <ScanOutlined />
                        </Button>
                    </Tooltip> */}
                </div>
                : null}

                { (single_slide_status||{}).slideState === C240SlideStatus.PREVIEW_DONE ? 
                <div>
                    {/* <Tooltip visible={this.state.barcodeVerify && this.isValidSlideName(local_slide_name)} placement="left" title={titleError} color="red" > */}
                        <Row>
                            <Input bordered="true" spellCheck="false" placeholder="Slide Name"
                                value={local_slide_name} 
                                style={ this.state.barcodeVerify && this.isValidSlideName(local_slide_name) ?
                                        { borderColor:"red", width: "10vw",borderRadius:"0px" }
                                        : { width:  "10vw",borderRadius:"0px" } } 
                                onChange={(e) => this.onChangeName(e, rack, tray, index)}></Input>
                        </Row>
                    {/* </Tooltip> */}
                    {/* <Tooltip placement="top" title={"Queue For Scan"}> */}
                        <Button
                            className="black-scan-btn"
                            onClick={(e) => {e.stopPropagation(); this.queueScan(index)}}
                            disabled={(this.state.barcodeVerify && this.isValidSlideName(local_slide_name))||this.props.cassetteQScanBtnDisable[index] || this.props.remove_queue_interaction}
                            style={{ marginTop:"10px"}}>
                            <ScanOutlined />
                            <span> Queue For Scan </span>
                        </Button>
                    {/* </Tooltip> */}
                    {/* <Tooltip placement="top" title={"Remove Preview"}> */}
                        {/* <Button
                            size="small"
                            className="scan-btn"
                            onClick={(e) => {e.stopPropagation(); this.removePreview(index)}}
                            disabled={this.props.remove_queue_interaction}
                            style={{ marginTop:"10px",textAlign:"center"}}>
                            <span> Discard Preview </span>
                        </Button> */}
                    {/* </Tooltip> */}
                </div>
                : null}

                { (single_slide_status||{}).slideState === C240SlideStatus.PREVIEW_IN_QUEUE
                     || (single_slide_status||{}).slideState === C240SlideStatus.SCAN_IN_QUEUE
                     || (single_slide_status||{}).slideState === C240SlideStatus.AUTO_SCAN_IN_QUEUE ? 
                queue_elems.map((value) => (value["rack"] === rack && value["tray"] === tray && value["slide"] === index)?
                <div>
                    {value !== queue_elems["2"] ?
                    // <Tooltip placement="top" title={"Prioritise Task"}>
                    <Button
                        className="scan-btn"
                        onClick={(e)=>{this.prioritiseTask(e, rack, tray, index, value["taskType"], null)}}>
                        <UpSquareOutlined />
                            <span> Prioritise Task </span>
                    </Button>
                    // </Tooltip>
                    :null}
                    {/* <Tooltip placement="top" title={"Cancel Task"}> */}
                    <Button
                        className="scan-btn"
                        onClick={(e)=>{this.removeTask(e, rack, tray, index, value["taskType"], null)}}
                        style={{marginTop:"5px"}}
                        >
                         <CloseCircleOutlined />
                            <span> Cancel Task </span>
                    </Button>
                    {/* </Tooltip> */}
                </div>
                :null)

                : null}
                </Col>
            </Row>
        });

        const trayKey = this.props.selectedCassette;
        const rack = parseInt(trayKey.split("T")[0].split("R")[1]);
        const tray = parseInt(trayKey.split("T")[1]);

        return (
                <div className="relative-position">
                    <div className={this.props.currentProcessIndex !== progressStage.LOAD_SLIDES ? "" : "blur"}>
                        { this.state.expandedSlide ?
                                <Row className='c240-editing-pane'>
                                        <SlideAreaSelectionComponent 
                                            id={this.state.selectedSlotIndex}
                                            device_id={this.props.device_id}
                                            defaultConfig={this.state.defaultConfig}
                                            cassetteSize={this.state.cassetteSize}
                                            startScanning={this.onStartScanning}
                                            closeExpadedSlideView={this.closeExpadedSlideView}
                                            preview={preview}
                                            cassetteKey={this.props.selectedCassette}
                                            onFinalizeSlideSettingsClick = {this.props.onFinalizeSlideSettingsClick}
                                            onFinalizedSlideSettings = {this.props.onFinalizedSlideSettings}
                                            slideType = {mySlideType}
                                        />
                                </Row>
                            :
                            <Row>
                                    {
                                    this.props.isCassetteEmpty ? 
                                    <Col offset={mySlideType === slideType.SLIDE_2_BY_3_INCH ? 4 : 0} span={23} >
                                        <Row span={23} style={{display:"flex", flexDirection: "row", justifyContent: "center", alignItems:"center", height: "95vh"}}>
                                            <Col style={{fontSize:"1.6vw"}} >No Cassette detected</Col>
                                        </Row>
                                    </Col>
                                     : 
                                    <Col offset={mySlideType === slideType.SLIDE_2_BY_3_INCH ? 4 : 0} span={23}>
                                            {slides}
                                    </Col>
                                    }
                            </Row>
                        }
                    </div>
                </div>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        deviceStatus: state.deviceStatusReducer[ownProps.device_id],
        c240LoaderStatus: state.c240LoaderReducer
    };
};

export default connect(mapStateToProps)(SingleCassetteComponent);